import { put, call, cancelled, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  FETCH_START,
  FETCH_END,
  FETCH_ERROR,
  FETCH_CANCEL,
} from 'actions/fetchActions';
import {
  functionSwitchHotSlaveBackendPath,
  functionSwitchFoodyIntegrationBackendPath,
  functionSwitchAutoAcceptFoodyOrdersBackendPath,
  functionSwitchEpaymentBackendPath,
  functionSwitchAssembledOrderLoadingInReportBackendPath,
  functionSwitchNewMenuServiceBackendPath
} from 'routes/advancedFunction/urls';
import { SHOP_ID_IN_WHITELIST } from 'routes/advancedFunction/utils';

const crudFetch = (restClient) => {
  function* handleFetch(action) {
    const { type, meta: { fetch: fetchMeta, ...meta }, callback } = action;
    let { payload } = action;
    const restType = fetchMeta;

    if (
      restType === 'GET_LIST'
      && (
        meta.apiPath === functionSwitchHotSlaveBackendPath
        || meta.apiPath === functionSwitchFoodyIntegrationBackendPath
        || meta.apiPath === functionSwitchAutoAcceptFoodyOrdersBackendPath
        || meta.apiPath === functionSwitchEpaymentBackendPath
        || meta.apiPath === functionSwitchAssembledOrderLoadingInReportBackendPath
        || meta.apiPath === functionSwitchNewMenuServiceBackendPath
    )) {
      payload = {value: SHOP_ID_IN_WHITELIST, ...payload};
    }

    yield [
      put({ type: `${type}_LOADING`, payload, meta }),
      put({ type: FETCH_START }),
    ];
    let response;
    try {
      response = yield call(restClient, restType, meta.apiPath, payload);
      if (!response.data) {
        throw new Error('REST response must contain a data key');
      }
      yield put({
        type: `${type}_SUCCESS`,
        payload: response,
        requestPayload: payload,
        meta: { ...meta, fetchResponse: restType, fetchStatus: FETCH_END },
      });
      if (callback) {
        callback();
      }
      yield put({ type: FETCH_END });
    } catch (error) {
      yield put({
        type: `${type}_FAILURE`,
        error: error.message ? error.message : error,
        requestPayload: payload,
        meta: {
          ...meta, fetchResponse: restType, fetchStatus: FETCH_ERROR,
          httpStatus: error.status
        },
      });
      yield put({ type: FETCH_ERROR, error });
    } finally {
      if (yield cancelled()) {
        yield put({ type: FETCH_CANCEL });
        return;
        /* eslint no-unsafe-finally:0 */
      }
    }
  }

  return function* watchCrudFetch() {
    yield [
      takeLatest(action => action.meta && action.meta.fetch && action.meta.cancelPrevious, handleFetch),
      takeEvery(action => action.meta && action.meta.fetch && !action.meta.cancelPrevious, handleFetch),
    ];
  };
};


export default crudFetch;



// WEBPACK FOOTER //
// ./src/sideEffect/saga/crudFetch.js